import { createAnimations } from "@tamagui/animations-react-native";
import { config as tamaguiBaseConfig } from "@tamagui/config/v3";
import type { GetProps } from "@tamagui/core";
import { radius, size, space, zIndex } from "@tamagui/themes";
import type { Input } from "tamagui";
import { createTamagui, createTokens } from "tamagui";

import { AnimationDuration } from "@/constants/UI";
import { ColorToken, ColorTokenValues } from "@/ui/theme/tokens";
import { isWeb } from "@/utils/platform.util";

const tokens = createTokens({
  borderColor: {
    primary: ColorTokenValues[ColorToken.NeutralLine],
    selected: ColorTokenValues[ColorToken.Primary100],
  },
  borderWidth: {
    // on web, just using "1" results in too-thick borders around cards
    primary: isWeb() ? "1px" : 1,
  },
  color: ColorTokenValues,
  radius,
  size,
  space,
  zIndex,
});

// currently, only 'spring' and 'timing' types supported by this library
// see: https://www.npmjs.com/package/@tamagui/animations-react-native?activeTab=code
const Animations = createAnimations({
  // more custom animation configs can be added here, by any name
  // see: https://reactnative.dev/docs/animated#spring
  bouncy: {
    damping: 9,
    mass: 0.9,
    stiffness: 150,
    type: "spring",
  },
  // see: https://reactnative.dev/docs/animated#timing
  fade: {
    delay: 0,
    duration: isWeb()
      ? AnimationDuration.FadeWeb
      : AnimationDuration.FadeMobile,
    type: "timing",
  },
  fadeSlow: {
    delay: 0,
    duration: 300,
    type: "timing",
  },
});

const tamaguiConfig = createTamagui({
  ...tamaguiBaseConfig,
  animations: Animations,
  tokens,
});

export type InputProps = GetProps<typeof Input>;
export { tokens };
export default tamaguiConfig;
